
/* eslint-disable no-unused-expressions */
import { defineComponent, ref } from 'vue'
import { Cart } from './type'
import { v4 as uuidv4 } from 'uuid'
import client from '@/helper/client'
import Translator, { Langs } from '@/helper/Translator'
import ResponseHandler from '@/helper/ResponseHandler'

enum State {
    defualt,
    pending,
    success,
}

const translator = new Translator(
    {
        cz: {
            default: 'Zkopírovat odkaz na košík',
            success: 'Zkopírovano do schránky',
        },
        sk: {
            default: 'Skopírovať odkaz na košík',
            success: 'Skopírovano do schránky',
        },
    },
    window.config.getLang() as Langs,
    Langs.cz
)

export default defineComponent({
    setup () {
        const state = ref(State.defualt)

        const save = async () => {
            state.value = State.pending

            const responseGetCart = await client.get('/cart/get-cart')
            if (!responseGetCart.ok) {
                new ResponseHandler(responseGetCart).handle()
                state.value = State.defualt
                return
            }

            const cart = await responseGetCart.json() as Cart
            const id = uuidv4()
            const payload = {
                id,
                vendorCode: window.config.getShopId(),
                productEshopList: cart.productEshopList,
            }

            const responseAddToCart = await client.post('/cart/share', payload)

            if (responseAddToCart.ok) {
                state.value = State.success
                navigator.clipboard.writeText(`${window.location.origin}/kosik/${id}`)
            } else {
                new ResponseHandler(responseAddToCart).handle()
            }

            setTimeout(() => { state.value = State.defualt }, 4000)
        }

        return {
            save,
            state,
            t: translator.translate,
            State,
        }
    },
})
